export const buildUrlWithParams = (params) => {
  // Get the current URL and its search parameters
  const currentUrl = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrl.search);

  // Add or update the parameters
  Object.keys(params).forEach(key => {
      searchParams.set(key, params[key]);
  });

  // Remove '/gallery' from the pathname if it exists
  let newPathname = currentUrl.pathname;

  // Construct the new URL with updated parameters
  const newUrl = `${newPathname}?${searchParams.toString()}`;

  // Ensure the URL starts with a '/'
  const normalizedUrl = `/${newUrl.replace(/^\//, '')}`;

  return normalizedUrl;
};
